import React from 'react';
import PropTypes from 'prop-types';
import { PaginationItem, PaginationLink } from 'reactstrap';

const Page = ({ text, active, handleClick, previous, next }) => (
  <PaginationItem active={active}>{text === '...'
    ? <span
      className="page-link"
      style={{
        backgroundColor: '#fff',
        borderColor: 'rgb(152, 185, 248) !important',
        color: '#257775',
        zIndex: 0,
        cursor: 'default',
      }}
    >{text}</span>
    : <PaginationLink
      previous={previous}
      next={next}
      style={active ? { cursor: 'default' } : {}}
      onClick={active ? () => {} : handleClick}
    >{text}</PaginationLink>}
  </PaginationItem>
);

Page.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleClick: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  previous: PropTypes.bool,
  next: PropTypes.bool,
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/_Pagination/_page.js